/** Installer home: gentle "keep installing" nudge once they're 60+ days without an order, or a lapsed notice. */
import React, { useEffect, useState } from 'react';
import { ShieldOff, Sparkles } from 'lucide-react';
import { wget } from '@/components/website/api';

export default function ActivityBanner() {
  const [a, setA] = useState(null);
  useEffect(() => { wget('/installer/approval-activity').then(setA).catch(() => {}); }, []);
  if (!a?.tracked || !['at_risk', 'final', 'lapsed'].includes(a.status)) return null;
  const lapsed = a.status === 'lapsed';
  return (
    <div className={`rounded-xl border px-4 py-3 flex items-start gap-3 mt-3 ${lapsed ? 'bg-red-50 border-red-200' : 'bg-amber-50 border-amber-200'}`} data-testid="home-activity-banner">
      <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${lapsed ? 'bg-red-700' : 'bg-amber-600'} text-white`}>{lapsed ? <ShieldOff className="w-5 h-5" /> : <Sparkles className="w-5 h-5" />}</div>
      <div className="text-sm min-w-0">
        <div className="font-bold text-slate-900">{lapsed ? 'Your Ox Approved status is paused' : `Keep your Ox Approved status active — ${a.days_left} day${a.days_left === 1 ? '' : 's'} left`}</div>
        <div className="text-slate-600 text-xs mt-0.5">{lapsed ? 'Place any order through the portal and it comes straight back. Need a hand with anything? Just get in touch.' : `It's been ${a.days_inactive} days since your last order. Approved installers keep their skills sharp by installing regularly — any order resets the clock. Anything we can help with?`}</div>
      </div>
    </div>
  );
}
